import React, { useEffect, useState } from "react";
import { getOptions } from "../../../helpers/options";
import { getAllProvinces } from "~v2/http-request/address";
import DropDownFormList from "~v2/components/DropDownFormList/DropdownFormList";

const DaytimeTouristPHResident = () => {
  const [options, setOptions] = useState([]);
  const generateOptions = async () => {
    let data = await getAllProvinces();
    if (data) {
      data = getOptions({ data, value: "provDesc", label: "provDesc" });
      return data;
    }
  };
  useEffect(() => {
    generateOptions().then((res) => setOptions(res));
  }, []);

  return (
    <>
      <DropDownFormList
        formListName="phResident"
        dropdownTitle="Select Province:"
        dropdownList={options}
        dropdownName="province"
        dropdownRuleMessage="Please select a province!"
        inputFields={[
          { name: "male", message: "Please input number of male" },
          { name: "female", message: "Please input number of female" },
        ]}
      />
    </>
  );
};

export default DaytimeTouristPHResident;
